<template>
    <div>
        <b class="w3-col flow-blue-color">{{wr.displayName}}</b>
        <div class="w3-col w-90pc w3-left">
            <div class="progress">
                <div :id="'bar-' + wr.id" class="bar"></div>
                <div class="occupied" v-if="isNaN(remainingPlaces)">
                    <i class="fa fa-spinner w3-opacity w3-disabled transform-animation"></i>
                </div>
                <div class="occupied" v-else>
                    {{remainingPlaces}}
                </div>
            </div>
        </div>
        <div class="w3-col w-10pc w3-center font-weight-bold pad-top-2px" v-if="wrCapacity">{{wrCapacity}}</div>
        <div class="w3-col w-10pc w3-center font-weight-bold pad-top-2px" v-else>
            <i class="fa fa-spinner w3-opacity w3-disabled transform-animation"></i>
        </div>
    </div>
</template>

<script>

    export default {
        name: "WRStatus",
        components: {},
        props: ['wr', 'patientsNumber', 'wrCapacity'],
        data() {
            return {
                displayLoading: false,
            }
        },
        mounted() {
            this.setWidth();
        },
        watch: {
            patientsNumber: function () {
                this.setWidth();
            },
            wrCapacity: function () {
                this.setWidth();
            }
        },
        computed: {
            remainingPlaces() {
                var space = !this.wrCapacity ? this.$t("NA") : this.wrCapacity - this.patientsNumber;
                return space;
            }
        },
        methods: {
            setWidth() {
                var elem = document.getElementById("bar-" + this.wr.id);
                var per = this.wrCapacity ? Math.min(Math.round((this.patientsNumber / this.wrCapacity) * 100), 100) : 0;
                elem.style.width = per + "%";
                if (per > 75 && per < 100) {
                    elem.classList.add('w3-deep-orange');
                }
                if (per >= 100) {
                    elem.classList.add('w3-red');
                }
            }

        }
    }
</script>

<style scoped>
    .pad-top-2px {
        padding-top: 2px;
    }
</style>